import * as Constants from '../constants';

const initialState = {
  isLoading: true,
  error: null,
  data: []
};

export default function(state = initialState, action) {
  switch (action.type) {
    case Constants.REQUEST_EINSTEIN_RECOMMENDATIONS:
      return { ...state, isLoading: true, error: null };
    case Constants.RECEIVE_EINSTEIN_RECOMMENDATIONS:
      if (action.error) {
        console.log(`Receive Data Extension Error  ${action.error}`);
        return {
          ...state,
          isLoading: false,
          error: action.error
        };
      }
      return {
        ...state,
        isLoading: false,
        data: action.einsteinDefaults,
        error: null
      };
    default:
      return state;
  }
}
